/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Sign_In_To_ViewInputs */



/**
* | output |
* | --- |
* | "Sign in to view" |
*
* @param {Artifact_Sign_In_To_ViewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_sign_in_to_view = /** @type {((inputs?: Artifact_Sign_In_To_ViewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Sign_In_To_ViewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmelden zum Anzeigen")
	return /** @type {LocalizedString} */ ("Sign in to view")
});